import styled from "styled-components";

/**
 * Container principal para cada segmento de voo.
 */
export const SegmentContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
  flex-direction: column;
  display: flex;
`;

/**
 * Container para os detalhes do voo.
 */
export const InfoFlight = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: center;
  display: flex;
`;

/**
 * Container para os detalhes do segmento.
 */
export const InfoSegment = styled.div`
  border-left: 1.5px solid ${({ theme }) => theme.colors.orange};
  padding-left: ${({ theme }) => theme.spacing(2.5)};
  margin-top: ${({ theme }) => theme.spacing(1)};
  margin-left: ${({ theme }) => theme.spacing(2.5)};
  gap: ${({ theme }) => theme.spacing(1)};
  flex-direction: column;
  position: relative;
  align-items: start;
  display: flex;

  & > span {
    line-height: 1.1;

    &:nth-child(2) {
      font-size: 0.8rem;
    }
  }

  &::before,
  &::after {
    background-color: ${({ theme }) => theme.colors.orange};
    border-radius: ${({ theme }) => theme.borderRadius.full};
    width: ${({ theme }) => theme.spacing(1.25)};
    height: ${({ theme }) => theme.spacing(1.15)};
    left: ${({ theme }) => theme.spacing(-0.65)};
    position: absolute;
    content: "";
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }
`;
